/*!

=========================================================
* BootstrapVue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import Vuex from 'vuex';
import store from './store';

// router setup
import router from './routes/router';
import VueSession from 'vue-session';
import VueI18n from 'vue-i18n';
import Vue2Editor from 'vue2-editor';

Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(Vue2Editor);

Vue.filter('titlecase', function (value) {
  if (!value) return '';
  return value
    .toString()
    .toLowerCase()
    .split(' ')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
});

Vue.filter('dashtotitlecase', function (value) {
  if (!value) return '';
  return value
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
});

const messages = {
  en: {
    message: {
      value: 'This is an example of content translation.',
    },
    learnMore: {
      value: 'Learn More',
    },
    homepage: { value: 'Homepage' },
    aboutUs: { value: 'About Us' },
    ourServices: { value: 'Our Services' },
    login: { value: 'Login' },
    welcome: { value: 'Welcome' },
    loginTitleDesc: {
      value: 'Please login to your account with email and password',
    },
    email: { value: 'Email' },
    password: { value: 'Password' },
    rememberMe: { value: 'Remember Me' },
    forgotPassword: { value: 'Forgot Password' },
    createNewAccount: { value: 'Create New Account' },
    failure: { value: 'Failure' },
    wrongEmailPassword: { value: 'Wrong email or password' },
    createAnAccount: { value: 'Create an account' },
    createAnAccountDesc: { value: 'Create an account to get started' },
    name: { value: 'Name' },
    nameAndEmail: { value: 'Name & Email' },
    passwordStrength: { value: 'Password Strength' },
    strong: { value: 'Strong' },
    medium: { value: 'Medium' },
    weak: { value: 'Weak' },
    aggreeWith: { value: 'I agree with the ' },
    privacyPolicy: { value: 'Privacy Policy' },
    createAccount: { value: 'Create account' },
    creatingAccount: { value: 'Creating account' },
    search: { value: 'Search' },
    myProfile: { value: 'My Profile' },
    settings: { value: 'Setting' },
    logout: { value: 'Logout' },
    language: { value: 'Language' },
    dashboard: { value: 'Dashboard' },
    profile: { value: 'Profile' },
    users: { value: 'Users' },
    addUser: { value: 'Add User' },
    viewDetailUser: { value: 'View Detail User' },
    editUser: { value: 'Edit User' },
    editUserPassword: { value: 'Edit User Password' },
    deleteUser: { value: 'Delete User' },
    deleteParameter: { value: 'Delete Parameter' },
    deleteUserConfirmDesc: {
      value: 'Are you sure you want to delete this user?',
    },
    deleteParameterConfirmDesc: {
      value: 'Are you sure you want to delete this parameter?',
    },
    addUser: { value: 'Add User' },
    username: { value: 'Username' },
    userInfo: { value: 'User Information' },
    confirmPassword: { value: 'Confirm Password' },
    userCreatedSuccess: { value: 'User created successfully' },
    userCreatedFailed: { value: 'User created failed' },
    userUpdatedSuccess: { value: 'User updated successfully' },
    userUpdatedFailed: { value: 'User updated failed' },
    parameters: { value: 'Parameters' },
    addDocument: { value: 'Add Document' },
    docInfo: { value: 'Document Information' },
    docName: { value: 'Document Name' },
    docType: { value: 'Document Type' },
    file: { value: 'File' },
    docCreatedSuccess: { value: 'Document created successfully' },
    docCreatedFailed: { value: 'Document created failed' },
    docUpdatedSuccess: { value: 'Document updated successfully' },
    docUpdatedFailed: { value: 'Document updated failed' },
    docDeletedSuccess: { value: 'Document deleted successfully' },
    docDeletedFailed: { value: 'Document deleted failed' },
    docDeletedConfirmDesc: {
      value: 'Are you sure you want to delete this document?',
    },
    docViewDetail: { value: 'View Detail Document' },
    docEdit: { value: 'Edit Document' },
    docDelete: { value: 'Delete Document' },
    orders: { value: 'Orders' },
    addOrder: { value: 'Add Order' },
    waitingForApproval: { value: 'Waiting for Approval' },
    approvedOrder: { value: 'Approved Order' },
    jobId: { value: 'Job ID' },
    orderType: { value: 'Order Type' },
    documents: { value: 'Documents' },
    phone: { value: 'Phone' },
    role: { value: 'Role' },
    previous: { value: 'Previous' },
    next: { value: 'Next' },
    orderInfo: { value: 'Order Information' },
    orderConfirm: { value: 'Order Confirmation' },
    preview: { value: 'Preview' },
    requestType: { value: 'Request Type' },
    description: { value: 'Description' },
    requestParam: { value: 'Request Parameters' },
    uploadLegalityDoc: { value: 'Upload Legality Document' },
    uploadRequirementDoc: { value: 'Upload Requirements Documents' },
    firstName: { value: 'First Name' },
    lastName: { value: 'Last Name' },
    address: { value: 'Address' },
    submit: { value: 'Submit' },
    errorParamRequired: { value: 'Please select at least one parameter' },
    errorLegalDocRequired: { value: 'Please upload legality document' },
    errorReqDocRequired: { value: 'Please upload requirements document' },
    contactInfo: { value: 'Contact Information' },
    confirmSubmitOrder: {
      value: 'You are about to submit this order. Are you sure?',
    },
    editUser: { value: 'Edit User' },
    failedToCreateOrder: { value: 'Failed to create order' },
    successCreateOrder: { value: 'Order created successfully' },
    viewDetailOrder: { value: 'View Detail Order' },
    deleteOrder: { value: 'Delete Order' },
    deleteOrderConfirmDesc: {
      value: 'Are you sure you want to delete this order?',
    },
    questionnaire: { value: 'Questionnaire' },
    questionnaireDesc: { value: 'Please fill in the questionnaire below' },
    addQuestionnaire: { value: 'Add Questionnaire' },
    questionnaireInfo: { value: 'Questionnaire Information' },
    question: { value: 'Question' },
    type: { value: 'Type' },
    addQuestion: { value: 'Add Question' },
    removeQuestion: { value: 'Remove Question' },
    response: { value: 'Response' },
    questions: { value: 'Questions' },
    viewDetailQuestion: { value: 'View Detail Question' },
    deleteQuestion: { value: 'Delete Question' },
    deleteQuestionConfirmDesc: {
      value: 'Are you sure you want to delete this question?',
    },
    branchOperational: { value: 'Branch Operational' },
    typeOfSample: { value: 'Type of Sample' },
    jobStatus: { value: 'Job Status' },
    customerName: { value: 'Customer Name' },
    fileSignature: { value: 'File Signature' },
    web: { value: 'Web' },
    errorBranchOperationalRequired: {
      value: 'Please select branch operational',
    },
    errorTypeOfSampleRequired: { value: 'Please select type of sample' },
    errorJobStatusRequired: { value: 'Please select job status' },
    identityType: { value: 'Identity Type' },
    uploadIdentityFile: { value: 'Upload Identity File' },
    uploadIdentityFileRequired: { value: 'Please upload identity file' },
    passwordNotMatch: { value: 'Password not match' },
    editPassword: { value: 'Edit Password' },
    approval: { value: 'Approval' },
    createInvoice: { value: 'Create Invoice' },
    paymentApproval: { value: 'Payment Approval' },
    incomingOrderWithJobId: { value: 'Incoming Order with Job ID' },
    from: { value: 'From' },
    withFollowingSummary: { value: 'with the following summary' },
    jobType: { value: 'Job Type' },
    createdAt: { value: 'Created At' },
    notes: { value: 'Notes' },
    approve: { value: 'Approve' },
    back: { value: 'Back' },
    successApproveOrder: { value: 'Order approved successfully' },
    orderAlreadyApproved: { value: 'Order already approved' },
    seeTheUploadedLegalFile: { value: 'See the uploaded legal file' },
    seeTheUploadedRequirementFile: {
      value: 'See the uploaded requirement file',
    },
    addInvoice: { value: 'Add Invoices' },
    cost: { value: 'Cost' },
    costInfo: { value: 'Cost Information' },
    errorFieldRequired: { value: 'Please input' },
    survey: { value: 'Survey' },
    info: { value: 'Information' },
    outputFinalResult: { value: 'Output / Final Result' },
    uploadDocument: { value: 'Upload Document' },
    documentName: { value: 'Document Name' },
    viewLogOrder: { value: 'View Log Order' },
    viewDetailInvoice: { value: 'View Detail Invoice' },
    uploadPaymentProof: { value: 'Upload Payment Proof' },
    downloadReport: { value: 'Download Report' },
    downloadCertificate: { value: 'Download Certificate' },
    orderLog: { value: 'Log Order' },
    orderHistory: { value: 'Order History' },
    trackOrderDesc: {
      value:
        'To track this order, you can copy the link or scan the qr code above',
    },
    descPaymentProof: {
      value:
        'Upload proof of payment can speed up the payment verification process',
    },
    descProofPaymentDisplay: {
      value: 'Make sure that the proof of payment displays:',
    },
    transferDateTime: { value: 'Transfer Date/Time' },
    exampleTransferDateTime: { value: 'example: 04/06/23 07:24:06' },
    succcessStatus: { value: 'Success Status' },
    exampleSuccessStatus: {
      value: 'example: Transfer SUCCESS, Transaction succeed',
    },
    recipientDetails: { value: 'Recipient Details' },
    exampleRecipientDetails: { value: 'example: Transfer to PT. ZAI' },
    transferAmount: { value: 'Transfer Amount' },
    exampleTransferAmount: { value: 'example: Rp.123,456,00' },
    uploadPaymentProof: { value: 'Upload Payment Proof' },
    fileRequired: { value: 'File is required' },
    confirmSubmitPayment: {
      value: 'You are about to submit this payment. Are you sure?',
    },
    feedback: { value: 'Feedback' },
    pleaseFillTheFeedback: {
      value: 'Please fill in your satisfaction with...',
    },
    excellent: { value: 'Excellent' },
    good: { value: 'Good' },
    average: { value: 'Average' },
    poor: { value: 'Poor' },
    bad: { value: 'Bad' },
    yes: { value: 'Yes' },
    no: { value: 'No' },
    feedbackType: { value: 'Feedback Type' },
    comments: { value: 'Comments' },
    questions: { value: 'Questions' },
    bugReports: { value: 'Bug Reports' },
    featureRequests: { value: 'Feature Requests' },
    other: { value: 'Other' },
    suggestionForImprovement: { value: 'Suggestion for Improvement' },
    feedbackTypeRequired: { value: 'Feedback Type is required' },
    confirmSubmitFeedback: {
      value: 'You are about to submit this feedback. Are you sure?',
    },
    otherFeedbackRequired: { value: 'Other Feedback field is required' },
    questionnaireRequired: { value: 'Questionnaire is required' },
    receiveSample: { value: 'Receive Sample' },
    sampling: { value: 'Sampling' },
    descReceiveSample: {
      value: 'I hereby mark that the sample from order with job id',
    },
    hasBeenReceived: { value: 'has been received' },
    preparation: { value: 'Preparation' },
    dueDate: { value: 'Due Date' },
    tax: { value: 'Tax' },
    invoiceUpdatedFailed: { value: 'Invoice updated failed' },
    invoiceCreatedFailed: { value: 'Invoice created failed' },
    createOrSeeInvoice: { value: 'Create or see invoice' },
    downloadInvoice: { value: 'Download Invoice' },
    submitInvoice: { value: 'Submit Invoice' },
    editInvoice: { value: 'Edit Invoice' },
    testing: { value: 'Testing' },
    basicAnalysis: { value: 'Basic Analysis' },
    jobApproval: { value: 'Job Approval' },
    reportApproval: { value: 'Report Approval' },
    action: { value: 'Action' },
    documentFile: { value: 'Document File' },
    see: { value: 'See' },
    approveJobDesc: { value: 'I hereby agree to approve this job result' },
    rectifiedJobDesc: {
      value: 'I hereby state that the results of the job need to be rectified.',
    },
    rejectJobDesc: { value: 'I hereby disagree and decline this job result' },
    jobResultInfo: { value: 'Job Result Information' },
    jobApproval: { value: 'Job Approval' },
    jobApprovalRequired: { value: 'Job Approval is required' },
    reportApprovalDesc: {
      value:
        'There is a draft report that needs to be reviewed on an order with job id ',
    },
    seeTheReportDraft: { value: 'See the report draft' },
    approveReportDesc: { value: 'I hereby agree to approve this report' },
    rectifiedReportDesc: {
      value: 'I hereby state that the report needs to be rectified.',
    },
    rejectReportDesc: { value: 'I hereby disagree and decline this report' },
    uploadCertificate: { value: 'Upload Certificate' },
    chooseReportApproval: { value: 'Choose Report Approval' },
    paymentApprovalDesc: {
      value: 'There is an incoming payment from order with job id ',
    },
    seeTheUploadedPaymentProof: { value: 'See the uploaded payment proof' },
    paymentProofNotFound: { value: 'Payment proof not found' },
    editProfile: { value: 'Edit Profile' },
    copyText: { value: 'Copy Text' },
    modifyOrder: { value: 'Modify Order' },
    confirmUpdateOrder: {
      value: 'You are about to update this order. Are you sure?',
    },
    descCreateCustomInvoice: { value: 'Create custom Invoice' },
    invoiceFile: { value: 'Invoice File' },
    invoiceFileRequired: { value: 'Invoice File is required' },
    customerInfo: { value: 'Customer Information' },
    sameOrderOkTitle: { value: 'Yes, Use Contract' },
    sameOrderNoTitle: { value: 'No' },
    descSameOrder: {
      value:
        'You have made an order with a similar type of job, are you interested in placing an order with a contract type?',
    },
    title: { value: 'Title' },
    requestInvoice: { value: 'Request Invoice' },
    requestInvoiceConfirm: {
      value: 'You are about to request an invoice. Are you sure?',
    },
    requestInvoiceSuccess: { value: 'Invoice request successfully' },
    invoiceRequested: { value: 'Invoice<br />requested' },
    identityFile: { value: 'Identity File' },
    addParameter: { value: 'Add Parameter' },
    paramInfo: { value: 'Parameter Information' },
    job: { value: 'Job' },
    price: { value: 'Price' },
    addParam: { value: 'Add Parameter' },
    editParam: { value: 'Edit Parameter' },
    fillAllData: { value: 'Please fill all data' },
    trackingOrder: { value: 'Track Order' },
    inputYourIdOrder: { value: 'Input your order ID ' },
    id: { value: 'ID' },
    orderId: { value: 'Order ID' },
    orderNotFound: { value: 'Order not found' },
    downloadDocument: { value: 'Download Document' },
    editDocument: { value: 'Edit Document' },
    deleteDocument: { value: 'Delete Document' },
    deleteDocConfirmDesc: {
      value: 'Are you sure you want to delete this document?',
    },
    changeFile: { value: 'Change File' },
    saveAsDraft: { value: 'Save as Draft' },
    initialSurvey: { value: 'Initial Survey' },
    finalSurvey: { value: 'Final Survey' },
    submitFinalSurvey: { value: 'Submit Final Survey' },
    alreadyApproved: { value: 'Already Approved' },
    numberOfSample: { value: 'Number of Sample' },
    contractApproval: { value: 'Contract Approval' },
    incomingContractOrderWithJobId: {
      value: 'Incoming Contract Order with Job ID',
    },
    approveContractDesc: {
      value: 'I hereby agree to approve this contract order',
    },
    rejectContractDesc: {
      value: 'I hereby disagree and decline this contract order',
    },
    chooseContractApproval: { value: 'Choose Contract Approval' },
    selectFile: { value: 'Select File' },
    seeTheCOAReportDraft: { value: 'See the COA report draft' },
    seeTheROAReportDraft: { value: 'See the ROA report draft' },
    COAReport: { value: 'COA Report' },
    ROAReport: { value: 'ROA Report' },
    downloadFeedbackResponse: { value: 'Download Feedback Response' },
  },
  id: {
    message: {
      value: 'Ini adalah contoh terjemahan konten.',
    },
    learnMore: {
      value: 'Pelajari Lebih Lanjut',
    },
    homepage: { value: 'Beranda' },
    aboutUs: { value: 'Tentang Kami' },
    ourServices: { value: 'Layanan Kami' },
    login: { value: 'Masuk' },
    welcome: { value: 'Selamat Datang' },
    loginTitleDesc: {
      value: 'Silahkan masuk ke akun anda dengan email dan password',
    },
    email: { value: 'Email' },
    password: { value: 'Kata Sandi' },
    rememberMe: { value: 'Ingat Saya' },
    forgotPassword: { value: 'Lupa Kata Sandi' },
    createNewAccount: { value: 'Buat Akun Baru' },
    failure: { value: 'Gagal' },
    wrongEmailPassword: { value: 'Email atau kata sandi salah' },
    createAnAccount: { value: 'Buat akun' },
    createAnAccountDesc: { value: 'Buat akun untuk memulai' },
    name: { value: 'Nama' },
    nameAndEmail: { value: 'Nama & Email' },
    passwordStrength: { value: 'Kekuatan Kata Sandi' },
    strong: { value: 'Kuat' },
    medium: { value: 'Sedang' },
    weak: { value: 'Lemah' },
    aggreeWith: { value: 'Saya setuju dengan ' },
    privacyPolicy: { value: 'Kebijakan Privasi' },
    createAccount: { value: 'Buat akun' },
    creatingAccount: { value: 'Membuat akun' },
    search: { value: 'Cari' },
    myProfile: { value: 'Profil Saya' },
    settings: { value: 'Pengaturan' },
    logout: { value: 'Keluar' },
    language: { value: 'Bahasa' },
    dashboard: { value: 'Dasbor' },
    profile: { value: 'Profil' },
    users: { value: 'Pengguna' },
    addUser: { value: 'Tambah Pengguna' },
    viewDetailUser: { value: 'Lihat Detail Pengguna' },
    editUser: { value: 'Edit Pengguna' },
    editUserPassword: { value: 'Edit Kata Sandi Pengguna' },
    deleteUser: { value: 'Hapus Pengguna' },
    deleteParameter: { value: 'Hapus Parameter' },
    deleteUserConfirmDesc: {
      value: 'Apakah anda yakin ingin menghapus pengguna ini?',
    },
    deleteParameterConfirmDesc: {
      value: 'Apakah anda yakin ingin menghapus parameter ini?',
    },
    addUser: { value: 'Tambah Pengguna' },
    username: { value: 'Username' },
    userInfo: { value: 'Informasi Pengguna' },
    confirmPassword: { value: 'Konfirmasi Kata Sandi' },
    userCreatedSuccess: { value: 'Pengguna berhasil dibuat' },
    userCreatedFailed: { value: 'Pengguna gagal dibuat' },
    userUpdatedSuccess: { value: 'Pengguna berhasil diupdate' },
    userUpdatedFailed: { value: 'Pengguna gagal diupdate' },
    parameters: { value: 'Parameters' },
    addDocument: { value: 'Tambah Dokumen' },
    docInfo: { value: 'Informasi Dokumen' },
    docName: { value: 'Nama Dokumen' },
    docType: { value: 'Tipe Dokumen' },
    file: { value: 'File' },
    docCreatedSuccess: { value: 'Dokumen berhasil dibuat' },
    docCreatedFailed: { value: 'Dokumen gagal dibuat' },
    docUpdatedSuccess: { value: 'Dokumen berhasil diupdate' },
    docUpdatedFailed: { value: 'Dokumen gagal diupdate' },
    docDeletedSuccess: { value: 'Dokumen berhasil dihapus' },
    docDeletedFailed: { value: 'Dokumen gagal dihapus' },
    docDeletedConfirmDesc: {
      value: 'Apakah anda yakin ingin menghapus dokumen ini?',
    },
    docViewDetail: { value: 'Lihat Detail Dokumen' },
    docEdit: { value: 'Edit Dokumen' },
    docDelete: { value: 'Hapus Dokumen' },
    orders: { value: 'Orders' },
    addOrder: { value: 'Tambah Order' },
    waitingForApproval: { value: 'Menunggu Persetujuan' },
    approvedOrder: { value: 'Order Disetujui' },
    jobId: { value: 'Job ID' },
    orderType: { value: 'Tipe Order' },
    documents: { value: 'Documents' },
    phone: { value: 'Telepon' },
    role: { value: 'Role' },
    previous: { value: 'Sebelumnya' },
    next: { value: 'Selanjutnya' },
    orderInfo: { value: 'Informasi Order' },
    orderConfirm: { value: 'Konfirmasi Order' },
    preview: { value: 'Pratinjau' },
    requestType: { value: 'Tipe Request' },
    description: { value: 'Deskripsi' },
    requestParam: { value: 'Parameter Request' },
    uploadLegalityDoc: { value: 'Upload Dokumen Legalitas' },
    uploadRequirementDoc: { value: 'Upload Dokumen Persyaratan' },
    firstName: { value: 'Nama Depan' },
    lastName: { value: 'Nama Belakang' },
    address: { value: 'Alamat' },
    submit: { value: 'Kirim' },
    errorParamRequired: { value: 'Silahkan pilih minimal satu parameter' },
    errorLegalDocRequired: { value: 'Silahkan upload dokumen legalitas' },
    errorReqDocRequired: { value: 'Silahkan upload dokumen persyaratan' },
    contactInfo: { value: 'Informasi Kontak' },
    confirmSubmitOrder: {
      value: 'Anda akan mengirimkan order ini. Apakah anda yakin?',
    },
    editUser: { value: 'Edit Pengguna' },
    failedToCreateOrder: { value: 'Gagal membuat order' },
    successCreateOrder: { value: 'Order berhasil dibuat' },
    viewDetailOrder: { value: 'Lihat Detail Order' },
    deleteOrder: { value: 'Hapus Order' },
    deleteOrderConfirmDesc: {
      value: 'Apakah anda yakin ingin menghapus order ini?',
    },
    questionnaire: { value: 'Kuesioner' },
    questionnaireDesc: { value: 'Silahkan isi kuesioner berikut' },
    questionnaireInfo: { value: 'Informasi Kuesioner' },
    addQuestionnaire: { value: 'Tambah Kuesioner' },
    questionnaireInfo: { value: 'Informasi Kuesioner' },
    question: { value: 'Pertanyaan' },
    type: { value: 'Tipe' },
    addQuestion: { value: 'Tambah Pertanyaan' },
    removeQuestion: { value: 'Hapus Pertanyaan' },
    response: { value: 'Jawaban' },
    questions: { value: 'Pertanyaan' },
    viewDetailQuestion: { value: 'Lihat Detail Pertanyaan' },
    deleteQuestion: { value: 'Hapus Pertanyaan' },
    deleteQuestionConfirmDesc: {
      value: 'Apakah anda yakin ingin menghapus pertanyaan ini?',
    },
    branchOperational: { value: 'Cabang Operasional' },
    typeOfSample: { value: 'Tipe Sample' },
    jobStatus: { value: 'Status Job' },
    customerName: { value: 'Nama Customer' },
    fileSignature: { value: 'File Signature' },
    web: { value: 'Web' },
    errorBranchOperationalRequired: {
      value: 'Silahkan pilih cabang operasional',
    },
    errorTypeOfSampleRequired: { value: 'Silahkan pilih tipe sample' },
    errorJobStatusRequired: { value: 'Silahkan pilih status job' },
    identityType: { value: 'Tipe Identitas' },
    uploadIdentityFile: { value: 'Upload File Identitas' },
    uploadIdentityFileRequired: { value: 'Silahkan upload file identitas' },
    passwordNotMatch: { value: 'Kata sandi tidak sama' },
    editPassword: { value: 'Edit Kata Sandi' },
    approval: { value: 'Persetujuan' },
    createInvoice: { value: 'Buat Invoice' },
    paymentApproval: { value: 'Persetujuan Pembayaran' },
    contractApproval: { value: 'Persetujuan Kontrak' },
    incomingOrderWithJobId: { value: 'Order Masuk dengan Job ID' },
    incomingContractOrderWithJobId: {
      value: 'Order Kontrak Masuk dengan Job ID',
    },
    from: { value: 'Dari' },
    withFollowingSummary: { value: 'dengan ringkasan berikut' },
    jobType: { value: 'Tipe Job' },
    createdAt: { value: 'Dibuat Pada' },
    notes: { value: 'Catatan' },
    approve: { value: 'Setujui' },
    back: { value: 'Kembali' },
    successApproveOrder: { value: 'Order berhasil disetujui' },
    orderAlreadyApproved: { value: 'Order sudah disetujui' },
    seeTheUploadedLegalFile: { value: 'Lihat file legalitas yang diupload' },
    seeTheUploadedRequirementFile: {
      value: 'Lihat file persyaratan yang diupload',
    },
    addInvoice: { value: 'Tambah Invoice' },
    cost: { value: 'Biaya' },
    costInfo: { value: 'Informasi Biaya' },
    errorFieldRequired: { value: 'Silahkan isi' },
    survey: { value: 'Survey' },
    info: { value: 'Informasi' },
    outputFinalResult: { value: 'Output / Hasil Akhir' },
    uploadDocument: { value: 'Upload Dokumen' },
    documentName: { value: 'Nama Dokumen' },
    viewLogOrder: { value: 'Lihat Log Order' },
    viewDetailInvoice: { value: 'Lihat Detail Invoice' },
    uploadPaymentProof: { value: 'Upload Bukti Pembayaran' },
    downloadReport: { value: 'Unduh Laporan' },
    downloadCertificate: { value: 'Unduh Sertifikat' },
    downloadDocument: { value: 'Unduh Dokumen' },
    editDocument: { value: 'Edit Dokumen' },
    deleteDocument: { value: 'Hapus Dokumen' },
    orderLog: { value: 'Log Order' },
    orderHistory: { value: 'Riwayat Order' },
    trackOrderDesc: {
      value:
        'Untuk melacak order ini, anda dapat menyalin link atau memindai qr code diatas',
    },
    descPaymentProof: {
      value:
        'Upload bukti pembayaran dapat mempercepat proses verifikasi pembayaran',
    },
    descProofPaymentDisplay: {
      value: 'Pastikan bukti pembayaran menampilkan:',
    },
    transferDateTime: { value: 'Tanggal/Waktu Transfer' },
    exampleTransferDateTime: { value: 'contoh: 04/06/23 07:24:06' },
    succcessStatus: { value: 'Status Sukses' },
    exampleSuccessStatus: {
      value: 'contoh: Transfer SUCCESS, Transaction succeed',
    },
    recipientDetails: { value: 'Detail Penerima' },
    exampleRecipientDetails: { value: 'contoh: Transfer to PT. ZAI' },
    transferAmount: { value: 'Jumlah Transfer' },
    exampleTransferAmount: { value: 'contoh: Rp.123,456,00' },
    uploadPaymentProof: { value: 'Upload Bukti Pembayaran' },
    fileRequired: { value: 'File wajib diisi' },
    confirmSubmitPayment: {
      value: 'Apakah kamu yakin mengirimkan pembayaran ini ? ',
    },
    feedback: { value: 'Umpan Balik' },
    pleaseFillTheFeedback: { value: 'Silahkan isi kepuasan anda dengan...' },
    excellent: { value: 'Sangat Baik' },
    good: { value: 'Baik' },
    average: { value: 'Cukup' },
    poor: { value: 'Buruk' },
    bad: { value: 'Sangat Buruk' },
    yes: { value: 'Ya' },
    no: { value: 'Tidak' },
    feedbackType: { value: 'Tipe Umpan Balik' },
    comments: { value: 'Komentar' },
    questions: { value: 'Pertanyaan' },
    bugReports: { value: 'Laporan Bug' },
    featureRequests: { value: 'Permintaan Fitur' },
    other: { value: 'Lainnya' },
    suggestionForImprovement: { value: 'Saran untuk Perbaikan' },
    feedbackTypeRequired: { value: 'Tipe Feedback wajib diisi' },
    confirmSubmitFeedback: {
      value: 'Apakah kamu yakin mengirimkan feedback ini ? ',
    },
    otherFeedbackRequired: { value: 'Kolom Feedback Lainnya wajib diisi' },
    questionnaireRequired: { value: 'Kuesioner wajib diisi' },
    receiveSample: { value: 'Terima Sample' },
    sampling: { value: 'Sampling' },
    descReceiveSample: {
      value: 'Saya dengan ini menandai bahwa sample dari order dengan job id',
    },
    hasBeenReceived: { value: 'telah diterima' },
    preparation: { value: 'Preparation' },
    dueDate: { value: 'Due Date' },
    tax: { value: 'Pajak' },
    invoiceUpdatedFailed: { value: 'Invoice gagal diupdate' },
    invoiceCreatedFailed: { value: 'Invoice gagal dibuat' },
    createOrSeeInvoice: { value: 'Buat atau lihat invoice' },
    downloadInvoice: { value: 'Unduh Invoice' },
    submitInvoice: { value: 'Kirim Invoice' },
    editInvoice: { value: 'Edit Invoice' },
    testing: { value: 'Testing' },
    basicAnalysis: { value: 'Analisis Dasar' },
    jobApproval: { value: 'Persetujuan Job' },
    reportApproval: { value: 'Persetujuan Laporan' },
    action: { value: 'Aksi' },
    documentFile: { value: 'File Dokumen' },
    see: { value: 'Lihat' },
    approveJobDesc: {
      value: 'Saya dengan ini menyetujui untuk menyetujui hasil job ini',
    },
    rectifiedJobDesc: {
      value: 'Saya dengan ini menyatakan bahwa hasil job perlu diperbaiki.',
    },
    rejectJobDesc: {
      value: 'Saya dengan ini tidak setuju dan menolak hasil job ini',
    },
    jobResultInfo: { value: 'Informasi Hasil Job' },
    jobApproval: { value: 'Persetujuan Job' },
    jobApprovalRequired: { value: 'Persetujuan Job wajib diisi' },
    reportApprovalDesc: {
      value: 'Ada draft laporan yang perlu ditinjau pada order dengan job id ',
    },
    seeTheReportDraft: { value: 'Lihat draft laporan' },
    approveReportDesc: {
      value: 'Saya dengan ini menyetujui untuk menyetujui laporan ini',
    },
    rectifiedReportDesc: {
      value: 'Saya dengan ini menyatakan bahwa laporan perlu diperbaiki.',
    },
    rejectReportDesc: {
      value: 'Saya dengan ini tidak setuju dan menolak laporan ini',
    },
    uploadCertificate: { value: 'Upload Sertifikat' },
    chooseReportApproval: { value: 'Pilih Persetujuan Laporan' },
    paymentApprovalDesc: {
      value: 'Ada pembayaran masuk dari order dengan job id ',
    },
    seeTheUploadedPaymentProof: {
      value: 'Lihat bukti pembayaran yang diupload',
    },
    paymentProofNotFound: { value: 'Bukti pembayaran tidak ditemukan' },
    editProfile: { value: 'Edit Profil' },
    copyText: { value: 'Salin Teks' },
    modifyOrder: { value: 'Ubah Order' },
    confirmUpdateOrder: {
      value: 'Anda akan mengubah order ini. Apakah anda yakin?',
    },
    descCreateCustomInvoice: { value: 'Buat invoice custom' },
    invoiceFile: { value: 'File Invoice' },
    invoiceFileRequired: { value: 'File Invoice wajib diisi' },
    customerInfo: { value: 'Informasi Customer' },
    sameOrderOkTitle: { value: 'Ya, Pakai Kontrak' },
    sameOrderNoTitle: { value: 'Tidak' },
    descSameOrder: {
      value:
        'Anda telah membuat order dengan tipe job yang mirip, apakah anda tertarik untuk melakukan order dengan tipe kontrak?',
    },
    title: { value: 'Judul' },
    requestInvoice: { value: 'Request Invoice' },
    requestInvoiceConfirm: {
      value: 'Anda akan request invoice. Apakah kamu yakin?',
    },
    requestInvoiceSuccess: { value: 'Invoice berhasil direquest' },
    invoiceRequested: { value: 'Invoice<br />direquest' },
    identityFile: { value: 'File Identitas' },
    addParameter: { value: 'Tambah Parameter' },
    paramInfo: { value: 'Informasi Parameter' },
    job: { value: 'Job' },
    price: { value: 'Harga' },
    addParam: { value: 'Tambah Parameter' },
    editParam: { value: 'Edit Parameter' },
    fillAllData: { value: 'Silahkan isi semua data' },
    trackingOrder: { value: 'Pelacakan Order' },
    inputYourIdOrder: { value: 'Masukkan ID Order Anda' },
    id: { value: 'ID' },
    orderId: { value: 'ID Order' },
    orderNotFound: { value: 'Order tidak ditemukan' },
    downloadDocument: { value: 'Unduh Dokumen' },
    changeFile: { value: 'Ganti File' },
    saveAsDraft: { value: 'Simpan sebagai Draft' },
    initialSurvey: { value: 'Survey Awal' },
    finalSurvey: { value: 'Final Survey' },
    submitFinalSurvey: { value: 'Kirim Final Survey' },
    alreadyApproved: { value: 'Sudah Disetujui' },
    numberOfSample: { value: 'Jumlah Sample' },
    approveContractDesc: {
      value: 'Saya dengan ini menyetujui untuk menyetujui order kontrak ini',
    },
    rejectContractDesc: {
      value: 'Saya dengan ini tidak setuju dan menolak order kontrak ini',
    },
    chooseContractApproval: { value: 'Pilih Persetujuan Kontrak' },
    selectFile: { value: 'Pilih File' },
    seeTheCOAReportDraft: { value: 'Lihat draft laporan COA' },
    seeTheROAReportDraft: { value: 'Lihat draft laporan ROA' },
    COAReport: { value: 'Laporan COA' },
    ROAReport: { value: 'Laporan ROA' },
    downloadFeedbackResponse: { value: 'Unduh Feedback Response' },
  },
};

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  messages,
});

var options = {
  persist: true,
};

Vue.use(VueSession, options);
// plugin setup
Vue.use(DashboardPlugin);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: (h) => h(App),
  router,
  i18n,
  store,
});
